/* eslint-disable */
// NOTE babel not transpile this file while compile bundle by webpack
if (window.CF && window.CF.keformsUrl) {
  var keformsUrl = window.CF.keformsUrl
  var publicPath = __webpack_public_path__

  publicPath = publicPath.slice(0, 1) == '/' ? publicPath.slice(1) : publicPath
  keformsUrl = keformsUrl.slice(-1) == '/' ? keformsUrl.slice(0, -1) : keformsUrl
  __webpack_public_path__ = keformsUrl + '/' + publicPath
}
